<template>
    <div class="shopSelect" :style="'background-image: linear-gradient(to bottom, ' + item.bgColor.color[0].item + ', ' + item.bgColor.color[1].item + ');'">
        <div class="background"></div>
        <div class="shopSelectBox" :style="'color:' + item.titleColor.color[0].item">
            <span>请选择店铺</span>
            <i class="el-icon-caret-bottom"></i>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
    data() {
        return {};
    }
};
</script>

<style scoped lang="scss">
.shopSelect{
    padding: 0 10px;
}
.shopSelectBox {
    width: 100%;
    height: 48px;
    padding: 0 10px;
    display: flex;
    align-items: center;

}
</style>